import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import Youtube from "../../assets/img/icon/youtube.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";

import AddLocationIcon from "@mui/icons-material/AddLocation";
import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
// import { validationsSubmits } from "./myBusinessValidationFunctions";
import { FormGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import ApModal from "../../common/AppoinmetModalppBtn";
import MediaModel from "../../common/mediaModel";
import MediaModelApp from "../../common/mediaModelApp";
import MediaCardInput from "../../common/mediaCardInput";
import PersonIcon from "@mui/icons-material/Person";
import { cityNameCll } from "../landingPage/landingPageApi";
import ImageUploader from "../../common/imageUpload";
import { formDataFn } from "../../common/commonUtils/commonUtilFunction";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import MultipleImageInput from "../../common/imgUploadMul";
import { GetBussiness, UpdateBusiness } from "../myBusiness/myBusinessApi";
import { validationsSubmits } from "../myBusiness/myBusinessValidationFunctions";
import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function InstituteInformation(instituteId) {
  const struct = {
    // id: 4,
    billerId: 0,
    logo: null,
    profileId: null,
    instituteName: "",
    branchName: "",
    briefAddress: "",
    state: "",
    district: "",
    city: "",
    pincode: null,
    area: "",
    latitude: 0,
    longitude: 0,
    emailId1: null,
    emailId2: null,
    mobileNumber1: "",
    mobileNumber2: null,
    whatsappNumber: "",
    google: "",
    website: "",
    instagram: "",
    facebook: null,
    youTube: null,
    pinterest: null,
    twitter: null,
    linkedIn: null,
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    image6: "",
    lastModifiedDate: "",
  };

  const [institute, setInstitute] = useState({ ...struct });
  const [selectedImages, setSelectedImages] = useState([]);

  const [hide, setHide] = useState(false);

  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getInstitute(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setInstitute({ ...struct, billerId });
        setSelectedImages([]);
        return;
      }

      setSelectedImages([]);
      setInstitute(obj);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };

  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  const submit = async () => {
    let obj = {
      Id: institute?.id || 0,
      BillerId: billerId,
      //  File: institute.File,
      ProfileId: institute.profileId,

      InstituteName: institute.instituteName,
      BranchName: institute.branchName,
      BriefAddress: institute.briefAddress,
      State: institute.state,
      District: institute.district,
      City: institute.city,
      Pincode: institute.pincode,
      Area: institute.area,

      Latitude: institute.latitude,
      Longitude: institute.longitude,

      EmailId1: institute.emailId1,
      EmailId2: institute.emailId2,
      MobileNumber1: institute.mobileNumber1,
      MobileNumber2: institute.mobileNumber2,
      WhatsappNumber: institute.whatsappNumber,

      Google: institute.google,
      Website: institute.website,
      Instagram: institute.instagram,
      Facebook: institute.facebook,
      YouTube: institute.youTube,
      Pinterest: institute.pinterest,
      Twitter: institute.twitter,
      LinkedIn: institute.linkedIn,
      //  File: selectedImages,
    };
    // selectedImages.forEach((ele, index) => {
    //   obj["File" + (index == 0 ? "" : index + 1)] = ele.file
    //     ? ele.file
    //     : ele.url;
    // });
    selectedImages.forEach((ele, index) => {
      obj[`File${index + 1}`] = ele.file ? ele.file : ele.url;
    });

    if (institute.File instanceof File) {
      obj.File = institute.File;
    }

    let payload = formDataFN(obj);

    if (!institute?.id) {
      await institueAdd(payload, () => {
        getData();
      });
    } else {
      await institueUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Institute Information{" "}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{
            margin: 0,
            padding: { xs: "0px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            height: "100vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: { sm: "end", xs: "center" },
                  }}
                >
                  {institute?.logoPreview ? (
                    // ✅ NEW IMAGE PREVIEW
                    <Box
                      component="img"
                      src={institute.logoPreview}
                      alt="Preview"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                      sx={{
                        width: { xs: "100px", sm: "150px", md: "200px" },
                        height: { xs: "100px", sm: "150px", md: "200px" },
                        cursor: "pointer",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : institute?.image1 ? (
                    // ✅ EXISTING IMAGE FROM API
                    <Box
                      component="img"
                      src={institute.image1}
                      alt="Existing"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                      sx={{
                        width: { xs: "100px", sm: "150px", md: "200px" },
                        height: { xs: "100px", sm: "150px", md: "200px" },
                        cursor: "pointer",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    // ✅ NO IMAGE
                    <Button
                      variant="outlined"
                      endIcon={<AddAPhotoOutlinedIcon />}
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                    >
                      Attach Image
                    </Button>
                  )}

                  <input
                    type="file"
                    id="imageUpload"
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setInstitute((prev) => ({
                          ...prev,
                          File: file,
                          logoPreview: URL.createObjectURL(file), // ✅ THIS drives preview
                        }));
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={9}
                sx={{
                  display: "flex",
                  justifyContent: { sm: "start", xs: "center" },
                  alignItems: "center",
                }}
              >
                <div>
                  {/* Inline MediaCardInput component */}
                  <Box
                    sx={{
                      padding: "10px",
                      backgroundColor: "#EEEEFF",
                      boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.25)",
                      borderRadius: "5px",
                      width: { xs: "250px", sm: "300px", md: "500px" },
                      margin: "10px 0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* <IconButton component="a" href={institute?.profileId} target="_blank" aria-label="go to link">

                      </IconButton> */}
                    <Box sx={{ width: "100%" }}>
                      <Typography
                        color="grey"
                        sx={{
                          margin: "0px !important",
                          padding: "0px !important",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          color: "#4E4E4E",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        <PersonIcon
                          sx={{
                            color: "black",
                            cursor: "pointer",
                            marginRight: "10px",
                          }}
                        />
                        Profile Id
                      </Typography>
                      <TextField
                        fullWidth
                        id="profileId"
                        label=""
                        variant="standard"
                        sx={{
                          margin: "0px !important",
                          padding: "15px 0 !important",
                          whiteSpace: "normal",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                        value={userDetail?.profileId}
                        onChange={(e) => {}}
                      />
                    </Box>
                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(
                          institute?.profileId || "",
                        );
                        alert("Link copied to clipboard!");
                      }}
                      sx={{
                        fontSize: { xs: "14px", sm: "13px", md: "20px" },
                      }}
                      aria-label="copy link"
                    >
                      <ContentCopyIcon
                        sx={{
                          color: "#4E4E4E",
                          fontSize: { xs: "14px", sm: "13px", md: "20px" },
                        }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        if (navigator.share) {
                          navigator
                            .share({
                              title: "Share Link",
                              url: institute?.profileId,
                            })
                            .catch((error) =>
                              console.error("Error sharing:", error),
                            );
                        } else {
                          alert(
                            "Share not supported on this browser. Link copied instead.",
                          );
                          navigator.clipboard.writeText(
                            institute?.profileId || "",
                          );
                        }
                      }}
                      aria-label="share link"
                    >
                      <ShareIcon
                        sx={{
                          color: "#4E4E4E",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      marginTop: "15px",
                      padding: "10px 40px",
                      height: "40px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Add Logo
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              id="instituteName"
              size="small"
              label="Institute Name"
              value={institute?.instituteName}
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  instituteName: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              id="branchName"
              label="Branch Name"
              size="small"
              value={institute?.branchName}
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  branchName: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              id="BrifeAddress"
              // label="Brief Address"
              label={
                <span>
                  Brief Address <span style={{ color: "red" }}>*</span>
                </span>
              }
              size="small"
              // value={institute?.address}
              value={
                institute?.briefAddress == null ||
                institute?.briefAddress === "null"
                  ? ""
                  : institute.briefAddress
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  briefAddress: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="state"
              size="small"
              label="State"
              value={
                institute?.state == null || institute?.state === "null"
                  ? ""
                  : institute.state
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  state: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="district"
              label="District"
              size="small"
              // value={institute?.district}
              value={
                institute?.district == null || institute?.district === "null"
                  ? ""
                  : institute.district
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  district: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="city"
              size="small"
              label="City"
              // value={institute?.city}
              value={
                institute?.city == null || institute?.city === "null"
                  ? ""
                  : institute.city
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  city: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="pincode"
              size="small"
              label="Pincode"
              // value={institute?.pincode}
              value={
                institute?.pincode == null || institute?.pincode === "null"
                  ? ""
                  : institute.pincode
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  pincode: e.target.value,
                });
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              id="area"
              size="small"
              // label="Area"
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              label={
                <span>
                  Area <span style={{ color: "red" }}>*</span>
                </span>
              }
              // value={institute?.area}
              value={
                institute?.area == null || institute?.area === "null"
                  ? ""
                  : institute.area
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  area: e.target.value,
                });
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="latitude"
              label="Latitude"
              size="small"
              // value={institute?.latitude}
              value={
                institute?.latitude == null || institute?.latitude === "null"
                  ? ""
                  : institute.latitude
              }
              onChange={(e) => {
                // setInstitute({
                //   ...institute,
                //   latitude: e.target.value,
                // });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              readOnly={true}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="longitude"
              label="Longitude"
              size="small"
              // value={institute?.longitude}
              value={
                institute?.longitude == null || institute?.longitude === "null"
                  ? ""
                  : institute.longitude
              }
              onChange={(e) => {
                // setInstitute({
                //   ...institute,
                //   longitude: e.target.value,
                // });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              readOnly={true}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Button
              sx={{
                height: "40px",
                width: { sm: "50%", xs: "100%" },
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "16px" },

                display: "flex",
                justifyContent: "space-between",
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              onClick={() => {
                cityNameCll((data) => {
                  console.log("location", data);
                  setInstitute((prev) => {
                    let temp = { ...prev };
                    temp.longitude = data?.lon;
                    temp.latitude = data?.lat;
                    console.log("temp", temp);
                    return {
                      ...temp,
                      mobileNumber: userDetail?.mobileNumber,
                    };
                  });
                  // asignCityName(data?.city)
                  // setCurrentLocation(data?.city)
                  // dispatch(setNavBarInputFields({location:data?.city}))
                });
              }}
              variant="contained"
              endIcon={<AddLocationIcon />}
            >
              Set Location
            </Button>
          </Grid>

          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="emailId1"
              size="small"
              label="Email Id"
              // value={institute?.mailID1}
              value={
                institute?.emailId1 == null || institute?.emailId1 === "null"
                  ? ""
                  : institute.emailId1
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  emailId1: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="emailId2"
              label="Email Id"
              size="small"
              // value={institute?.mailID2}
              value={
                institute?.emailId2 == null || institute?.emailId2 === "null"
                  ? ""
                  : institute.emailId2
              }
              onChange={(e) => {
                setInstitute({
                  ...institute,
                  emailId2: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="mobileNumber1"
              // label="Mobile Number"
              label={
                <span>
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </span>
              }
              size="small"
              InputProps={{
                readOnly: true,
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              // value={userDetail?.mobileNumber}
              value={
                institute?.mobileNumber1 == null ||
                institute?.mobileNumber1 === "null"
                  ? ""
                  : institute.mobileNumber1
              }
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="mobileNumber2"
              label="Alternate Mobile Number"
              size="small"
              // value={institute?.mobileNumber2}
              value={
                institute?.mobileNumber2 == null ||
                institute?.mobileNumber2 === "null"
                  ? ""
                  : institute.mobileNumber2
              }
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setInstitute({
                    ...institute,
                    mobileNumber2: value,
                  });
                }
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="whatsappNumber"
              label="Whatsapp Mobile Number"
              size="small"
              // value={institute?.mobileNumber2}
              value={
                institute?.whatsappNumber == null ||
                institute?.whatsappNumber === "null"
                  ? ""
                  : institute.whatsappNumber
              }
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setInstitute({
                    ...institute,
                    whatsappNumber: value,
                  });
                }
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <FormControl
              fullWidth
              size="small"
              onClick={() => {
                setHide(true);
              }}
            >
              <InputLabel id="tags-label" className="mulish">
                Social Media Link
              </InputLabel>
              <Select
                labelId="tags-label"
                id="businessCategory"
                readOnly={true}
                name="businessCategory"
                value={optionVal(institute)}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    serviceTo: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
                input={<OutlinedInput label="Services" />}
              >
                <MenuItem value={optionVal(institute)}>
                  <ListItemText
                    primary={optionVal(institute)}
                    primaryTypographyProps={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      fontFamily: "Montserrat",
                    }}
                  />
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <MultipleImageInput
              selectedImages={selectedImages}
              setSelectedImages={setSelectedImages}
            />
          </Grid>

          <Grid item xs={12}>
            {/* <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{ mt: 3, mb: 2 }}
              >
                Save
              </Button> */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* <ApModal open={} setOpen={} /> */}
      {institute != null && (
        <MediaModelApp
          open={hide}
          setOpen={setHide}
          modelData={{
            google: "",
            website: "",
            instagram: "",
            facebook: "",
            youTube: "",
            pinterest: "",
            twitter: "",
            linkedIn: "",
            ...institute,
          }}
          setModalData={setInstitute}
        />
      )}
    </Grid>
  );
}
